module.exports = __webpack_public_path__ + "img/43_46.44a840c8.png";